import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { breakpoints } from '@metro-ui/tokens/js';
export var BasicTableCell = styled(function (_a) {
    var children = _a.children, hasNoWrap = _a.doesNotWrap, colSpan = _a.colSpan, isAlignedRight = _a.isAlignedRight, props = __rest(_a, ["children", "doesNotWrap", "colSpan", "isAlignedRight"]);
    return (React.createElement("td", __assign({ colSpan: colSpan }, props), children));
})(function (_a) {
    var doesNotWrap = _a.doesNotWrap, isAlignedRight = _a.isAlignedRight;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 8px;\n\n    ", "\n\n    ", "\n\n  &:first-of-type {\n      padding-left: 16px;\n    }\n\n    &:last-child {\n      @media (min-width: ", ") {\n        padding-right: 16px;\n      }\n    }\n  "], ["\n    padding: 8px;\n\n    ", "\n\n    ", "\n\n  &:first-of-type {\n      padding-left: 16px;\n    }\n\n    &:last-child {\n      @media (min-width: ", ") {\n        padding-right: 16px;\n      }\n    }\n  "])), doesNotWrap && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      white-space: nowrap;\n    "], ["\n      white-space: nowrap;\n    "]))), isAlignedRight && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      text-align: right;\n    "], ["\n      text-align: right;\n    "]))), breakpoints.m);
});
BasicTableCell.propTypes = {
    doesNotWrap: PropTypes.bool,
    colSpan: PropTypes.number,
    isAlignedRight: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=BasicTableCell.js.map